import React from 'react'

interface ChevronUpIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const ChevronUpIcon: React.FC<ChevronUpIconProps> = ({
  color = '#000',
  gradient,
  width = 26,
  height = 26,
  alt = 'Chevron up icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 26 26'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M19.067 16.067a.625.625 0 01-.884 0l-5.558-5.558-5.558 5.558a.625.625 0 11-.884-.884l6-6a.625.625 0 01.884 0l6 6a.625.625 0 010 .884z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default ChevronUpIcon
